module.exports = __webpack_public_path__ + "img/checkedSlr.687e08d0.png";